import { useState } from "react";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { api } from "../lib/api";

export default function DropAlert() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      toast.success(data.already ? "Already on the list. Patience, collector." : "You're on the list. Rare finds incoming.");
      setEmail("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "That email looks off. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="drop-alert" className="border-t-2 border-charcoal bg-charcoal py-14 text-cream">
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-wide text-mint">Drop alerts</p>
          <h2 className="mt-2 font-display text-3xl font-extrabold uppercase tracking-tight text-yellow sm:text-4xl lg:text-5xl">
            Rare finds drop fast
          </h2>
          <p className="mt-3 max-w-md text-cream/75">
            One email when a genuinely rare piece hits the catalogue. No spam, no newsletters, no mercy.
          </p>
        </div>
        <form onSubmit={submit} className="flex w-full max-w-md flex-col gap-3 sm:flex-row">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@whatever.com"
            data-testid="drop-alert-email"
            className="flex-1 rounded-full border-2 border-cream bg-transparent px-5 py-3.5 text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:ring-2 focus:ring-mint"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="drop-alert-submit"
            className="btn-chunky border-cream bg-yellow px-6 py-3.5 text-sm text-charcoal shadow-hard-cream hover:bg-mint disabled:opacity-50"
          >
            <Bell className="h-4 w-4" /> {busy ? "Joining..." : "Ping me"}
          </button>
        </form>
      </div>
    </section>
  );
}
